/**
 * Configuración temporal para departamentos
 * Mientras se configura el backend Laravel
 */

// Datos temporales de departamentos de Guatemala
export const DEPARTAMENTOS_TEMP = [
  { id: 1, nombre: 'Guatemala' },
  { id: 2, nombre: 'El Progreso' },
  { id: 3, nombre: 'Sacatepéquez' },
  { id: 4, nombre: 'Chimaltenango' },
  { id: 5, nombre: 'Escuintla' },
  { id: 6, nombre: 'Santa Rosa' },
  { id: 7, nombre: 'Sololá' },
  { id: 8, nombre: 'Totonicapán' },
  { id: 9, nombre: 'Quetzaltenango' },
  { id: 10, nombre: 'Suchitepéquez' },
  { id: 11, nombre: 'Retalhuleu' },
  { id: 12, nombre: 'San Marcos' },
  { id: 13, nombre: 'Huehuetenango' },
  { id: 14, nombre: 'Quiché' },
  { id: 15, nombre: 'Baja Verapaz' },
  { id: 16, nombre: 'Alta Verapaz' },
  { id: 17, nombre: 'Petén' },
  { id: 18, nombre: 'Izabal' },
  { id: 19, nombre: 'Zacapa' },
  { id: 20, nombre: 'Chiquimula' },
  { id: 21, nombre: 'Jalapa' },
  { id: 22, nombre: 'Jutiapa' }
];

// Municipios por departamento (algunos ejemplos)
export const MUNICIPIOS_TEMP: { [key: number]: Array<{ id: number; nombre: string; codigo_postal?: string }> } = {
  1: [ // Guatemala
    { id: 101, nombre: 'Guatemala', codigo_postal: '01001' },
    { id: 102, nombre: 'Santa Catarina Pinula', codigo_postal: '01002' },
    { id: 103, nombre: 'San José Pinula', codigo_postal: '01003' },
    { id: 104, nombre: 'San José del Golfo', codigo_postal: '01004' },
    { id: 105, nombre: 'Palencia', codigo_postal: '01005' },
    { id: 106, nombre: 'Chinautla', codigo_postal: '01006' },
    { id: 107, nombre: 'San Pedro Ayampuc', codigo_postal: '01007' },
    { id: 108, nombre: 'Mixco', codigo_postal: '01008' },
    { id: 109, nombre: 'San Pedro Sacatepéquez', codigo_postal: '01009' },
    { id: 110, nombre: 'San Juan Sacatepéquez', codigo_postal: '01010' },
    { id: 111, nombre: 'San Raymundo', codigo_postal: '01011' },
    { id: 112, nombre: 'Chuarrancho', codigo_postal: '01012' },
    { id: 113, nombre: 'Fraijanes', codigo_postal: '01013' },
    { id: 114, nombre: 'Amatitlán', codigo_postal: '01014' },
    { id: 115, nombre: 'Villa Nueva', codigo_postal: '01015' },
    { id: 116, nombre: 'Villa Canales', codigo_postal: '01016' },
    { id: 117, nombre: 'San Miguel Petapa', codigo_postal: '01017' }
  ],
  3: [ // Sacatepéquez
    { id: 301, nombre: 'Antigua Guatemala', codigo_postal: '03001' },
    { id: 302, nombre: 'Jocotenango', codigo_postal: '03002' },
    { id: 303, nombre: 'Pastores', codigo_postal: '03003' },
    { id: 304, nombre: 'Sumpango', codigo_postal: '03004' },
    { id: 305, nombre: 'Santo Domingo Xenacoj', codigo_postal: '03005' },
    { id: 306, nombre: 'Santiago Sacatepéquez', codigo_postal: '03006' },
    { id: 307, nombre: 'San Bartolomé Milpas Altas', codigo_postal: '03007' },
    { id: 308, nombre: 'San Lucas Sacatepéquez', codigo_postal: '03008' },
    { id: 309, nombre: 'Santa Lucía Milpas Altas', codigo_postal: '03009' },
    { id: 310, nombre: 'Magdalena Milpas Altas', codigo_postal: '03010' },
    { id: 311, nombre: 'Santa María de Jesús', codigo_postal: '03011' },
    { id: 312, nombre: 'Ciudad Vieja', codigo_postal: '03012' },
    { id: 313, nombre: 'San Miguel Dueñas', codigo_postal: '03013' },
    { id: 314, nombre: 'Alotenango', codigo_postal: '03014' },
    { id: 315, nombre: 'San Antonio Aguas Calientes', codigo_postal: '03015' },
    { id: 316, nombre: 'Santa Catarina Barahona', codigo_postal: '03016' }
  ],
  9: [ // Quetzaltenango
    { id: 901, nombre: 'Quetzaltenango', codigo_postal: '09001' },
    { id: 902, nombre: 'Salcajá', codigo_postal: '09002' },
    { id: 903, nombre: 'San Mateo', codigo_postal: '09003' },
    { id: 904, nombre: 'La Esperanza', codigo_postal: '09004' },
    { id: 905, nombre: 'Cantel', codigo_postal: '09005' }
  ]
};
